/* eslint-disable react/prop-types */
//@ts-nocheck
import React from 'react';
import { CommentsListItem } from './comments-list-item';

export function CommentsList(props) {
  return (
    <ul>
      {props.comments.map((c) => (
        <CommentsListItem
          key={c.id}
          {...c}
          simpleView={props.simpleView}
          onCommentDelete={props.onCommentDelete}
          onCommentUpdate={props.onCommentUpdate}
        />
      ))}
    </ul>
  );
}
